<template>
  <div class="home flex_content">

    <div id="context_bar">

    </div>

    <titlePage>
        <template slot="titleBody">
            <h1 class="page-title title is-size-1">{{ $t('modules.dashboard.title') }}</h1>
        </template>
    </titlePage>


    <div id="index_positions_content" class="hero flex">
        <div class="hero-body flex_content">
            <div class="container has-text-centered ">

                <div class="notification db_notification is-warning" v-if="trialExpired" v-html="$t('modules.dashboard.notifTrialExpired')"></div>

                <div class="columns">
                    <div class="column">
                        <LastEvalsWrap />
                        <LastPositionsWrap />
                    </div>
                    <div class="column is-one-third">
                        <ItemsCounters />
                    </div>
                </div>
            </div>
        </div>
    </div>


  </div>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import LastEvalsWrap from "../components/lastEvalsWrap"
import LastPositionsWrap from "../components/lastPositionsWrap"
import ItemsCounters from "../components/itemsCounters"

export default {
    name: 'RecruiterDashboard',
    components: {
        TitlePage,
        LastEvalsWrap,
        LastPositionsWrap,
        ItemsCounters
    },
    beforeCreate() {
        this.$store.dispatch('EvalStore/indexEvals', {page: 1})
        this.$store.dispatch('PositionStore/indexPositions', {page: 1})
        this.$store.dispatch('RefStore/indexRefs', 'custom')
        this.$store.dispatch('UserStore/getStats')
    },
    data(){
        return {
            uAccess: JSON.parse(localStorage.getItem('account'))
        }
    },
    computed: {
        isTrial(){
            return this.uAccess.trial
        },
        trialExpired(){
            return (this.uAccess.trial && this.uAccess.trial_expired)
        }
    }
}
</script>
<style lang="scss">
.db_notification{
    border-radius: 4px!important;
}
</style>